import { createFileRoute } from "@tanstack/react-router";
import PageLoggedOut from "@/pages/account/logged-out";

export const Route = createFileRoute("/app/account/logged-out")({
  component: RouteComponent,
});

function RouteComponent() {
  return <PageLoggedOut />;
}
